import Hammer from 'hammerjs';
import Carousel from './Carousel';
import calendar from './Calendar';
import { Moment } from 'moment-timezone';
import { debounce } from 'throttle-debounce';
import HttpMethod from '../../../app/enums/HttpMethod';
import { showMoreAppointmentsEvent } from './Appointment';
import { isTabletSize, isSubscribed } from '../functions';
import CalendarEvent from '../../../app/models/CalendarEvent';
import { localizedRoute, moment } from '../../../app/support/helpers';

export type DataQuery = {
    start: Moment,
    end: Moment
};

/**
 * Navigation control event
 *
 * @return {void}
 */
export function navigationControlEvent() {

	$('.calendarWrapper').on('click', '.navigateToLeft, .navigateToRight', function(event) {
		event.preventDefault();

		event.currentTarget.classList.contains('navigateToLeft') ? navigateToLeft() : navigateToRight();
	});
}




/*
|--------------------------------------------------------------------------
| Navigate to left actions
|--------------------------------------------------------------------------
*/


/**
 * Get last day|week appointments
 *
 * @return {void}
 */
export function navigateToLeft() {

	isTabletSize() ? getLastDayAppointments() : getLastWeekAppointments();
}




export function getLastWeekAppointments() {
	// console.log('Get LAST WEEK appointments');

	var doctor_id = $('.doc').val();
    // console.log('doctor_id : ', doctor_id);

    var cuurent_day = $('.cuurent_day').val();
    // console.log('$cuurent_day : ', $('cuurent_day'));
    // console.log('cuurent_day : ', cuurent_day);
    var speciality  = $('.calendar_speciality').val();

    var now         = new Date();
    // console.log('now : ', now);
    // @ts-ignore
    var date_start  = new Date(cuurent_day);
    // console.log('date_start : ', date_start);
    // @ts-ignore
    var date_end    = new Date(cuurent_day);
    // console.log('date_end : ', date_end);

    date_start.setDate(date_start.getDate() - 6);
    // console.log('date_start after sub of 7 days : ', date_start);
    date_end.setDate(date_end.getDate() - 1);
    // console.log('date_end after sub of 1 days : ', date_end);

    var Dstart = date_start.getFullYear() + "-" + ("0" + (date_start.getMonth() + 1)).slice(-2) + "-" + ("0" + date_start.getDate()).slice(-2);
    var Dend = date_end.getFullYear() + "-" + ("0" + (date_end.getMonth() + 1)).slice(-2) + "-" + ("0" + date_end.getDate()).slice(-2);


    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', doctor_id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: Dstart,
            end: Dend
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('week')
            .setStart(moment(Dstart))
            .setEnd(moment(Dend));

        $('.calendarWrapper').html(calendar.render());

        $('.cuurent_day').val(Dstart);

        showMoreAppointmentsEvent();

        nextAvailability();
    })
    .always(always);
}




export function getLastDayAppointments() {
	// console.log('Get LAST DAY appointments');

	var doctor_id   = $('.doc').val();
	// console.log('doctor_id : ', doctor_id);
	var cuurent_day = $('.cuurent_day').val();
	// console.log('cuurent_day : ', cuurent_day);
	var speciality  = $('.calendar_speciality').val();
	// console.log('speciality : ', speciality);

    var now         = new Date();
    // console.log('now : ', now);
    // @ts-ignore
    var date        = new Date(cuurent_day);
    // console.log('date : ', date);

    date.setDate(date.getDate() - 1);

    var next_day = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);

    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', doctor_id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: moment(next_day).startOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
            end: moment(next_day).endOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('single_day')
            .setStart(moment(next_day))
            .setEnd(moment(next_day));

        $('.calendarWrapper').html(calendar.render());

        // after the request is executed, the nex_day became
        // the current day
        $('.cuurent_day').val(next_day);

        showMoreAppointmentsEvent();

        Carousel.init();

        calendarSwipeEvent();

        nextAvailability();
    })
    .always(always);
}




/*
|--------------------------------------------------------------------------
| Navigate to right actions
|--------------------------------------------------------------------------
*/


/**
 * Get next day|week appointments
 *
 * @return {void}
 */
export function navigateToRight() {

	isTabletSize() ? getNextDayAppointments() : getNextWeekAppointments();
}




export function getNextWeekAppointments() {
	// console.log('Get NEXT WEEK appointments');

    var id          = $('.doc').val();
    var cuurent_day = $('.cuurent_day').val();
    var speciality  = $('.calendar_speciality').val();
    var now         = new Date();
    // @ts-ignore
    var date_start  = new Date(cuurent_day);
    // @ts-ignore
    var date_end    = new Date(cuurent_day);

    date_start.setDate(date_start.getDate() + 6);
    date_end.setDate(date_end.getDate() + 11);

    var Dstart = date_start.getFullYear() + "-" + ("0" + (date_start.getMonth() + 1)).slice(-2) + "-" + ("0" + date_start.getDate()).slice(-2);
    // console.log('Dstart : ', Dstart);
    var Dend = date_end.getFullYear() + "-" + ("0" + (date_end.getMonth() + 1)).slice(-2) + "-" + ("0" + date_end.getDate()).slice(-2);

    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: Dstart,
            end: Dend
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('week')
            .setStart(moment(Dstart))
            .setEnd(moment(Dend));

        $('.calendarWrapper').html(calendar.render());

        $('.cuurent_day').val(Dstart);

        showMoreAppointmentsEvent();

        nextAvailability();
    })
    .always(always);
}




export function getNextDayAppointments() {
	// console.log('Get NEXT DAY appointments');

	var doctor_id   = $('.doc').val();
	// console.log('doctor_id : ', doctor_id);
	var cuurent_day = $('.cuurent_day').val();
	// console.log('cuurent_day : ', cuurent_day);
	var speciality  = $('.calendar_speciality').val();
	// console.log('speciality : ', speciality);

    var now         = new Date();
    // console.log('now : ', now);
    // @ts-ignore
    var date        = new Date(cuurent_day);
    // console.log('date : ', date);

    date.setDate(date.getDate() + 1);

    var next_day = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);

    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', doctor_id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: moment(next_day).startOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
            end: moment(next_day).endOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('single_day')
            .setStart(moment(next_day))
            .setEnd(moment(next_day));

        $('.calendarWrapper').html(calendar.render());

        // after the request is executed, the nex_day became
        // the current day
        $('.cuurent_day').val(next_day);

        // attach dom events

        showMoreAppointmentsEvent();

        Carousel.init();

        calendarSwipeEvent();

        nextAvailability();
    })
    .always(always);
}




/*
|--------------------------------------------------------------------------
| On swip navigate in calendar
|--------------------------------------------------------------------------
*/

export function calendarSwipeEvent() {

	// calendar that's needs a swipe functionality
	//  only exist if doctor is subscribed
	if (isTabletSize() && isSubscribed()) {

		var DIRECTION_NONE   = 1;
		var DIRECTION_LEFT   = 2;
		var DIRECTION_RIGHT  = 4;
		var DIRECTION_UP     = 8;
		var DIRECTION_DOWN   = 16;

		// Get a reference to an element
		var navigation       = document.querySelector('.swipeDoctorCalendar');

        if (! navigation) {
            // Stop, otherwise Hammer throw's an exception
            return;
        }

		var $navigateToLeft  = $('#navigateToLeft');

		var $navigateToRight = $('#navigateToRight');

		// Create a manager to manager the element
		var manager          = new Hammer.Manager(navigation);

		// Create a recognizer
		var Swipe            = new Hammer.Swipe();

		// Add the recognizer to the manager
		manager.add(Swipe);

		// Subscribe to a desired event
		manager.on('swipe', (e) => {

			var direction = e.offsetDirection;
			// console.log('direction : ', direction);
			if (direction === DIRECTION_RIGHT) {

				if ($navigateToLeft.is(':visible')) {
					// console.log('$navigateToLeft.click()');
            		$navigateToLeft.click();
                }

			} else if (direction === DIRECTION_LEFT) {

				// console.log('$navigateToRight.click()');
				$navigateToRight.click();
			}
		});
	}
}




/*
|--------------------------------------------------------------------------
| On window resize reload the calendar
|--------------------------------------------------------------------------
*/

export function onResizeReloadCalendar() {
    // console.log('onResizeReloadCalendar');
	// doctor page profile has two version
	// on for subscribed doctors, and the other for
	// non subscribed doctors. the calendar that needs to be
	// reloaded on resize is set in subscribed doctor page, and most
	// of all to prevent firing unnecessary request, also to prevent conflict
	// in non subscribed doctors calendar (alternative doctors)
	if (isSubscribed()) {

		$(window).on('resize', debounce(300, (event) => {
            // console.log('event : ', event);
			if (isTabletSize()) {

				// reload calendar grab the current day

				getCurrentDayAppointments();


			} else {

				// reload calendar grab the current week

				getCurrentWeekAppointments();
			}
		}));
	}
}




/*
|--------------------------------------------------------------------------
| Reload calendar actions
|--------------------------------------------------------------------------
*/

/**
 *
 * @return {[type]} [description]
 */
export function getCurrentDayAppointments() {

	// console.log('Get CURRENT DAY appointments');

	var doctor_id   = $('.doc').val();
	// console.log('doctor_id : ', doctor_id);
	var cuurent_day = $('.cuurent_day').val();
	// console.log('cuurent_day : ', cuurent_day);
	var speciality  = $('.calendar_speciality').val();
	// console.log('speciality : ', speciality);

    var now         = new Date();
    // console.log('now : ', now);
    // @ts-ignore
    var date        = new Date(cuurent_day);

    var next_day = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);

    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', doctor_id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: moment(next_day).startOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
            end: moment(next_day).endOf('day').format(window.moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('single_day')
            .setStart(moment(next_day))
            .setEnd(moment(next_day));

        $('.calendarWrapper').html(calendar.render());

        // after the request is executed, the nex_day became
        // the current day
        $('.cuurent_day').val(next_day);

        // attach dom events

        showMoreAppointmentsEvent();

        Carousel.init();

        calendarSwipeEvent();

        nextAvailability();
    })
    .always(always);
}




export function getCurrentWeekAppointments() {
	// console.log('Get CURRENT WEEK appointments');

    var id          = $('.doc').val();
    var cuurent_day = $('.cuurent_day').val();
    var speciality  = $('.calendar_speciality').val();
    var now         = new Date();
    // @ts-ignore
    var date_start  = new Date(cuurent_day);
    // @ts-ignore
    var date_end    = new Date(cuurent_day);

    date_end.setDate(date_end.getDate() + 5);

    var Dstart = date_start.getFullYear() + "-" + ("0" + (date_start.getMonth() + 1)).slice(-2) + "-" + ("0" + date_start.getDate()).slice(-2);

    var Dend = date_end.getFullYear() + "-" + ("0" + (date_end.getMonth() + 1)).slice(-2) + "-" + ("0" + date_end.getDate()).slice(-2);

    $.ajax({
        url: localizedRoute('frontend.practitioners.availabilities', id),
        type: HttpMethod.GET,
        cache: false,
        data: {
            start: Dstart,
            end: Dend
        },
        beforeSend: beforeSend
    })
    .done(function(data) {
        const availabilities = CalendarEvent.new(data as []);
        calendar.setEvents(availabilities)
            .setType('week')
            .setStart(moment(Dstart))
            .setEnd(moment(Dend));

        $('.calendarWrapper').html(calendar.render());

        $('.cuurent_day').val(Dstart);

        showMoreAppointmentsEvent();

        nextAvailability();
    })
    .always(always);
}




/*
|--------------------------------------------------------------------------
| nextAvailability
|--------------------------------------------------------------------------
*/

export function nextAvailability() {

	$('.nextAvailability').on('click', function(event) {
		event.preventDefault();

		var start;
		var nextAvailabilityData = CalendarEvent.new($(this).data('nextAvailability') as {});

		if (isTabletSize()) {

			// the behavior of getNextDayAppointments() is it adds one day
			// to the current day to get get the next day
			// so we make our current day set to one day before
			// to keep getNextDayAppointments() behavior consistent
			start  = new Date(nextAvailabilityData.start);

		    start.setDate(start.getDate() - 1);

		} else {

			// the behavior of getNextWeekAppointments() is it adds 6 days
			// to the current day to get get the next week
			// so we make our current day set to one week before
			// to keep getNextWeekAppointments() behavior consistent
			start  = new Date(nextAvailabilityData.start);

		    start.setDate(start.getDate() - 6);
		}

		$('.doc').val(nextAvailabilityData.practitioner_id);
	    $('.cuurent_day').val(moment(start).format('YYYY-MM-DD'));

		navigateToRight();
	});
}


function beforeSend(): void {
	var $bar_loader          = $('.bar-loader');
	var $schedules_container = $('.schedulesContainer');
	var $calendar_controllers= $('#navigateToLeft, #navigateToRight');

    $bar_loader.show();

    $schedules_container.css({
        opacity: '0.3',
        pointerEvents: 'none'
    });

    $calendar_controllers.css({
        opacity: '0.3',
        pointerEvents: 'none'
    });
}

function always(): void {
    var $bar_loader           = $('.bar-loader');
	var $schedules_container  = $('.schedulesContainer');
	var $calendar_controllers = $('#navigateToLeft, #navigateToRight');

    $bar_loader.hide();

    $schedules_container.css({
        opacity: '1',
        pointerEvents: 'initial'
    });

    $calendar_controllers.css({
        opacity: '1',
        pointerEvents: 'initial'
    });
}
